import CustomSorting from '@public/icons/sorting_new.svg';
import React, { SVGProps } from 'react';

type CustomSortingWrapperProps = SVGProps<SVGSVGElement>;
const CustomSortingWrapper: React.FC<CustomSortingWrapperProps> = (props) => {
  return <CustomSorting {...props} />;
};

export default CustomSortingWrapper;
